const rulesetId = 'table-hover-ruleset';
const injectCssRuleset = (ruleSet: string) => {
  const foundRuleSet = document.getElementById(rulesetId);

  if (foundRuleSet) {
    foundRuleSet.textContent = ruleSet;
    return;
  }

  const style = document.createElement('style');
  style.id = 'table-hover-ruleset';
  style.appendChild(document.createTextNode(ruleSet));
  document.head.appendChild(style);
};

const createSingleHoverSelector = (tableSelector: string, position: number) => {
  const IGNORE_FIRST_COLUMN_POSITION = 1;

  // highlight header column self
  // ignore first row in table header, because it spans all city columns
  const headerSelfSelector = `
    ${tableSelector} tr:nth-child(2) > th.ant-table-cell:nth-child(${position}):hover
  `;

  // highlight column body cells, when hover on header column
  const columnBodyCellOnHoverHeaderColumnSelector = `
    ${tableSelector}:has(tr:nth-child(2) > th.ant-table-cell:nth-child(${position}):hover)
      tr > td:nth-child(${position + IGNORE_FIRST_COLUMN_POSITION})
  `;

  // highlight column body cells on body cell hover
  const columnBodyCellOnCellColumnHoverSelector = `
    ${tableSelector}:has(tr > td.ant-table-cell:nth-child(${position + IGNORE_FIRST_COLUMN_POSITION}):hover) tr > td:nth-child(${position + IGNORE_FIRST_COLUMN_POSITION})
  `;

  // highlight column header cells on body cell hover
  const columnHeaderOnBodyCellHoverSelector = `
    ${tableSelector}:has(tr > td.ant-table-cell:nth-child(${position}):hover) tr:nth-child(2) > th:nth-child(${position - IGNORE_FIRST_COLUMN_POSITION})
  `;

  return [
    headerSelfSelector,
    columnBodyCellOnHoverHeaderColumnSelector,
    columnBodyCellOnCellColumnHoverSelector,
    columnHeaderOnBodyCellHoverSelector,
  ]
    .map((selector) => selector.trim())
    .join(', ');
};

const createHoverSelectors = ({
  tableSelector,
  startPosition,
  endPosition,
}: any) => {
  const selectors = [];

  for (let i = startPosition; i <= endPosition; i++) {
    const selector = createSingleHoverSelector(tableSelector, i);
    selectors.push(selector);
  }

  const result = selectors.join(', ');

  return result;
};

export const createTableHoverCss = ({
  tableSelector,
  firstColumnPosition,
  lastColumnPosition,
}: {
  tableSelector: string;
  firstColumnPosition: number;
  lastColumnPosition: number;
}) => {
  const selectors = createHoverSelectors({
    tableSelector,
    startPosition: firstColumnPosition,
    endPosition: lastColumnPosition,
  });

  const baseRowCellHoverRule = `
    ${tableSelector} .ant-table-row:hover > td.ant-table-cell {
      background: #fff3cb !important;
    }`;

  // for first header column cells
  const ruleSet = `
    ${baseRowCellHoverRule}

    ${selectors} {
      background: #fff3cb !important;
    }
  `;

  injectCssRuleset(ruleSet);

  // clean up
  return () => {
    const foundRuleSet = document.getElementById(rulesetId);
    if (foundRuleSet) {
      foundRuleSet.remove();
    }
  };
};
